module.exports = __webpack_public_path__ + "img/OTU.bffa01e3.png";